import React, { useState } from 'react';
import useHead from '../useHead';
import { adminFetch, storeToken } from './adminAuth';

export default function AdminLogin({ onAuthed }) {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    const token = btoa(`${name}:${password}`);
    try {
      const res = await adminFetch(token, '/api/v1/admin/users');
      if (!res.ok) throw new Error('Invalid credentials');
      storeToken(token);
      onAuthed(token);
    } catch (err) {
      setError('Invalid credentials');
    } finally {
      setLoading(false);
    }
  }

  useHead({
    title: 'Admin — ConvoLines',
    description: '',
    path: '/admin',
    noindex: true,
  });

  return (
    <form className="admin-login" onSubmit={handleSubmit}>
      <h1>Admin</h1>
      <input
        type="text"
        placeholder="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        autoFocus
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      {error && <p className="admin-error">{error}</p>}
      <button type="submit" disabled={loading}>
        {loading ? 'Checking…' : 'Sign in'}
      </button>
    </form>
  );
}
